// 调入报价单搜索条件
export const searchList = [
  { label: '询价单编号', value: 'orderCode' },
  { label: '客户名称', value: 'cusName' },
  { label: '产品名称', value: 'proName' },
  { label: '产品型号', value: 'proType' },
  { label: '订货号', value: 'orderNumber' }
]
// 客户调用搜索条件
export const customerList = [
  { label: '客户名称', value: 'cusName' },
  { label: '联系人', value: 'ccContacts' },
  { label: '联系电话', value: 'ccPhone' },
  { label: '联系手机', value: 'ccMobile' }
]
